export default __webpack_public_path__ + "static/media/5.658de8b2.png";